import api from './api';
import { GoFrugalSyncState } from './orderService';

export const userService = {
    list: async (filterData: any) => {
        const params = new URLSearchParams();

        if (filterData.page) {
            params.set('page', filterData.page.toString());
        }
        if (filterData.limit) {
            params.set('limit', filterData.limit.toString());
        }
        if (filterData.search) {
            params.set('search', filterData.search);
        }
        if (filterData.usertype) {
            params.set('usertype', filterData.usertype);
        }
        if (filterData.type) {
            params.set('type', filterData.type);
        }
        if (filterData.goFrugalSyncStatus) {
            params.set('goFrugalSyncStatus', filterData.goFrugalSyncStatus);
        }
        if (filterData.sort?.column) {
            params.set('sort', filterData.sort.column);
            if (filterData.sort.dir) {
                params.set('order', filterData.sort.dir);
            }
        }

        const response = await api.get(`users?${params.toString()}`);
        return response.data;
    },

    sync: async () => {
        const response = await api.post('users/sync', {});
        return response.data;
    },

    add: async (userData: any) => {
        const response = await api.post('users', userData);
        return response.data;
    },

    getDetails: async (userId: string) => {
        const response = await api.get(`users/${userId}`);
        return response.data;
    },

    edit: async (userId: string, userData: any) => {
        const response = await api.put(`users/${userId}`, userData);
        return response.data;
    },

    updateStatus: async (userId: string, data: any) => {
        const response = await api.put(`users/${userId}/toggle`, data);
        return response.data;
    },

    toggleRole: async (userId: string) => {
        const response = await api.patch(`users/${userId}/toggle-role`, {});
        return response.data;
    },

    delete: async (userId: string) => {
        const response = await api.delete(`users/${userId}`);
        return response.data;
    },

    getSyncStatus: async (): Promise<{
        success: boolean;
        data: {
            isRunning: boolean;
            progress: {
                totalPages: number;
                processedPages: number;
                totalFetched: number;
                created: number;
                updated: number;
                failed: number;
            };
            lastError?: string;
        }
    }> => {
        const response = await api.get('users/sync/status');
        return response.data;
    },

    syncToGoFrugal: async (): Promise<{ success: boolean; data: GoFrugalSyncState; message: string }> => {
        const response = await api.post('users/sync-to-gofrugal', {});
        return response.data;
    },

    getGoFrugalSyncStatus: async (): Promise<{ success: boolean; data: GoFrugalSyncState }> => {
        const response = await api.get('users/sync-to-gofrugal/status');
        return response.data;
    }
};
